// extracted by mini-css-extract-plugin
export default {"unauthorized":"Unauthorized_unauthorized__mEUQl","title":"Unauthorized_title__TA6Nh","message":"Unauthorized_message__sWmKP","button":"Unauthorized_button__76LRU"};